// extracted by mini-css-extract-plugin
export default {"steps":"steps_aR6G1","contentPadding":"contentPadding_fdzbq"};